import { render, staticRenderFns } from "./archive-list.vue?vue&type=template&id=068861ac"
import script from "./archive-list.vue?vue&type=script&lang=js"
export * from "./archive-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports